import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';

@Directive({
    selector: '[msShowInEpcot]',
})
export class ShowInEpcotDirective implements OnInit {
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private viewContainer = inject(ViewContainerRef);
    private epcotConfig = inject(EpcotConfig);

    @Input() msShowInEpcot: boolean;

    ngOnInit(): void {
        if (this.msShowInEpcot === this.epcotConfig.isEnabled) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
